export default "__VITE_ASSET__Ki4p31ME__"